<template>
    <div class="relative max-w-[300px]">
        <p class="font-bold text-black">
            {{ title }}
        </p>
        <AutocompleteRadio
            :options="{ clearWhenUpdateItems: true }"
            :items="solds"
            placeholder="Selecione um sold"
            class="max-w-[350px]"
            @updateValue="store = $event"
        />
    </div>
</template>
<script>
import AutocompleteRadio from "@/Components/AutocompleteRadio.vue";

export default {
    components: {
        AutocompleteRadio,
    },
    props: {
        title: String,
        items: Object,
        inputName: String,
        enable: {
            type: Boolean,
            default: true,
        },
        options: {
            type: Object,
            default: {
                clearWhenUpdateItems: false,
            },
        },
        onChange: Function,
        placeholder: String,
    },
    emits: ["updateValue"],
    data() {
        return {
            store: "",
        };
    },
    computed: {
        solds() {
            return this.items.map(({ id, name, codeSoldBroker }) => ({
                    id,
                    name: `${name} ${codeSoldBroker}`,
                }));
        },
    },
    watch: {
        store: {
            handler(newValue) {
                this.$emit("updateValue", {
                    store: newValue,
                });
            },
            immediate: true,
        },
    },
};
</script>
<style scoped>
.noscroll::-webkit-scrollbar {
    display: none; /* Hide scrollbar for Chrome, Safari and Opera */
}
.noscroll {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}
</style>
